// extracted by mini-css-extract-plugin
export default {"mobileLayout":"MobileNavigationDrawer_mobileLayout__EXfgW"};